import _styled from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Prompt.tsx - don't use without guarding on useSmallScreenInterface - it won't look pretty!
 */
import { useRef, useState } from "react";
import { useTheme } from "styled-components";
import FadeIn from "../Transitions/FadeIn/FadeIn";
import SlideUpFadeIn from "../Transitions/SlideUpFadeIn/SlideUpFadeIn";
import TourExplanationBox from "../Tour/TourExplanationBox";
import TourPrefaceBox from "../Tour/TourPrefaceBox";
import CloseButton from "../Generic/CloseButton";
import Text from "../../Styled/Text";
import Box from "../../Styled/Box";
import Button from "../../Styled/Button";
import Spacing from "../../Styled/Spacing";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HelpPrompt = _ref => {
  let {
    title,
    content,
    dismissLabel,
    acceptLabel,
    onDismiss,
    onAccept,
    isVisible
  } = _ref;
  const theme = useTheme();
  // This is required so we can do nested animations
  const [childrenVisible, setChildrenVisible] = useState(isVisible);
  const fadeRef = useRef(null);
  const slideInRef = useRef(null);
  return /*#__PURE__*/_jsx(FadeIn, {
    isVisible: isVisible,
    onEnter: () => setChildrenVisible(true),
    transitionProps: {
      onExiting: () => setChildrenVisible(false)
    },
    nodeRef: fadeRef,
    children: /*#__PURE__*/_jsxs(_StyledBox, {
      ref: fadeRef,
      fullWidth: true,
      fullHeight: true,
      position: "absolute",
      children: [/*#__PURE__*/_jsx(TourPrefaceBox, {
        onClick: onDismiss,
        role: "presentation",
        "aria-hidden": "true",
        pseudoBg: true
      }), /*#__PURE__*/_jsx(SlideUpFadeIn, {
        isVisible: childrenVisible,
        nodeRef: slideInRef,
        children: /*#__PURE__*/_jsxs(TourExplanationBox, {
          ref: slideInRef,
          longer: true,
          paddedRatio: 4,
          column: true,
          style: {
            right: 25,
            bottom: 45
          },
          children: [/*#__PURE__*/_jsx(CloseButton, {
            color: theme.darkWithOverlay,
            topRight: true,
            onClick: () => onDismiss()
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 2
          }), /*#__PURE__*/_jsx(Text, {
            extraExtraLarge: true,
            bold: true,
            textDarker: true,
            children: title
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 3
          }), /*#__PURE__*/_jsx(Text, {
            light: true,
            medium: true,
            textDarker: true,
            children: content
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 4
          }), /*#__PURE__*/_jsx(Text, {
            medium: true,
            children: /*#__PURE__*/_jsxs(Box, {
              centered: true,
              children: [/*#__PURE__*/_jsx(Button, {
                secondary: true,
                fullWidth: true,
                shortMinHeight: true,
                onClick: e => {
                  e.stopPropagation();
                  onDismiss();
                },
                children: dismissLabel
              }), /*#__PURE__*/_jsx(Spacing, {
                right: 3
              }), /*#__PURE__*/_jsx(Button, {
                primary: true,
                fullWidth: true,
                shortMinHeight: true,
                textProps: {
                  noFontSize: true
                },
                onClick: e => {
                  e.stopPropagation();
                  onAccept();
                },
                children: acceptLabel
              })]
            })
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 1
          })]
        })
      })]
    })
  });
};
export default HelpPrompt;
var _StyledBox = _styled(Box).withConfig({
  displayName: "HelpPrompt___StyledBox",
  componentId: "sc-1lyivb5-0"
})(["z-index:", ";"], p => Number(p.theme.frontComponentZIndex) + 100);